
      // Include Lightbox
      import PhotoSwipeLightbox from './photoswipe/photoswipe-lightbox.esm.js';
      import PhotoSwipe from './photoswipe/photoswipe.esm.js';

      const arrowPrevSVGString = '<svg height="100" viewBox="0 0 46 100" width="46" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(-1 0 0 -1 46 100)"><path d="m0 6.273 6.273-6.273 6.273 6.273" fill="none" opacity="1" stroke="#fff" stroke-miterlimit="10" stroke-width="2" transform="matrix(0 1 -1 0 26.082 43.672)"/></g></svg>';
      const arrowNextSVGString = '<svg height="100" viewBox="0 0 46 100" width="46" xmlns="http://www.w3.org/2000/svg"><path d="m0 6.273 6.273-6.273 6.273 6.273" fill="none" opacity="1" stroke="#fff" stroke-miterlimit="10" stroke-width="2" transform="matrix(0 1 -1 0 26.082 43.672)"/></svg>';
      const closeSVG = '<svg height="36" viewBox="0 0 36 36" width="36" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h36v36h-36z" fill="#d0d0d0" opacity="0"/><g fill="#fff" opacity="1" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -244.689 245.128)"><path d="m337 24.5h18v2h-18z"/><path d="m0 0h18v2h-18z" transform="matrix(0 1 -1 0 347 16.5)"/></g></svg>';
      const shareSVG = '<svg height="36" viewBox="0 0 36 36" width="36" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h36v36h-36z" fill="#d0d0d0" opacity="0"/><g fill="none" opacity="1" stroke="#fff" stroke-width="2"><g><circle cx="11" cy="18" r="4" stroke="none"/><circle cx="11" cy="18" fill="none" r="3"/></g><g><circle cx="25" cy="11" r="4" stroke="none"/><circle cx="25" cy="11" fill="none" r="3"/></g><g><circle cx="25" cy="25" r="4" stroke="none"/><circle cx="25" cy="25" fill="none" r="3"/></g><path d="m23 12-10 5"/><path d="m23 24-10-5"/></g></svg>';
      const fullScreenSVG = '<svg height="36" viewBox="0 0 36 36" width="36" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h36v36h-36z" fill="#d0d0d0" opacity="0"/><g fill="none" opacity="1" stroke="#fff" stroke-miterlimit="10" stroke-width="2"><path d="m0 4 4-4 4 4" transform="matrix(-.70710678 -.70710678 .70710678 -.70710678 11.914 28.243)"/><path d="m0 4 4-4 4 4" transform="matrix(.70710678 .70710678 -.70710678 .70710678 24.086 7.758)"/><path d="m0 4 4-4 4 4" transform="matrix(.70710678 -.70710678 .70710678 .70710678 6.258 13.414)"/><path d="m0 4 4-4 4 4" transform="matrix(-.70710678 .70710678 -.70710678 -.70710678 29.742 22.585)"/></g></svg>';
      const zoomSVG = '<svg height="36" viewBox="0 0 36 36" width="36" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h36v36h-36z" fill="#d0d0d0" opacity="0"/><g fill="none" opacity="1" stroke="#fff" stroke-width="2" transform="translate(-1363.5 -30.827)"><path d="m14.5 9.828a7 7 0 1 1 -7-7 7 7 0 0 1 7 7z" stroke-miterlimit="10" transform="translate(1372 36)"/><path d="m1390.5 57.828-6.55-6.691" stroke-miterlimit="10"/><path d="m1375.5 45.827h8"/><path d="m0 0h8" transform="matrix(0 1 -1 0 1379.5 41.827)"/></g></svg><svg height="36" viewBox="0 0 36 36" width="36" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h36v36h-36z" fill="#d0d0d0" opacity="0"/><g fill="none" opacity="1" stroke="#fff" stroke-width="2" transform="translate(-1363.5 -30.827)"><path d="m14.5 9.828a7 7 0 1 1 -7-7 7 7 0 0 1 7 7z" stroke-miterlimit="10" transform="translate(1372 36)"/><path d="m1390.5 57.828-6.55-6.691" stroke-miterlimit="10"/><path d="m1375.5 45.827h8"/></g></svg>';

      let is_fullScreen = false;
      function requestFullscreen(target) {
         if (target.webkitRequestFullscreen) {
            target.webkitRequestFullscreen();
         } else if (target.mozRequestFullScreen) {
            target.mozRequestFullScreen();
         } else if (target.msRequestFullscreen) {
            target.msRequestFullscreen();
         } else if (target.requestFullscreen) {
            target.requestFullscreen();
         }

         is_fullScreen = true;
      }
      function exitFullscreen() {
         if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
         } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
         } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
         } else if(document.cancelFullScreen) {
            document.cancelFullScreen();
         } else if(document.exitFullscreen) {
            document.exitFullscreen();
         }
         is_fullScreen = false;
      }

      /**
       * Returns a string of parent ID for the main product image
       *
       * @returns {string|null} - Parent ID or null if not found
       */
      function getClassForMainImage() {
         // Gets the div with the class name "product-content__detail-col-slider__main"
         const divTags = document.querySelector('.product-content__detail-col-slider__main');
         let parentId = null;
         if(divTags) {
            // Check for all the images within the div
            let imgTags = divTags.querySelectorAll('img');
            imgTags.forEach(tag => {
               // Check if the image is not hidden
               const style = window.getComputedStyle(tag);
               if (style.display !== 'none') {
                  // Find the nearest parent div with an ID
                  parentId = tag.closest('div').id;
                  return;
               }
            });
         }
         return parentId || null;
      }

      /**
       * Sets the data attributes for the parent element to dimensions
       * @param {Object} img - The image element for which dimensions to be set
       * @returns {void}
       */
      function setPswpDimensions(img) {
         const a = img.parentElement; // get reference to the parent <a> element
         a.dataset.pswpWidth = img.naturalWidth;
         a.dataset.pswpHeight = img.naturalHeight;
      }

      let mainDivId = getClassForMainImage(); // Get the main image id

      // Set dimensions for slide images
      $('img.pswp__original_img').each((index, img) => {
         // Set the image dimensions after loaded
         $(img).on('load contentLoadImage', () => setPswpDimensions(img));
      });

      // Set dimensions for the main image
      $(document).ready(function() {
         let img = $(`img.${mainDivId}`);
         if(img.length) {
            setPswpDimensions($(`img.${mainDivId}`)[0]);
         }
      });

      const lightbox = new PhotoSwipeLightbox({
         arrowPrevSVG: arrowPrevSVGString,
         arrowNextSVG: arrowNextSVGString,
         closeSVG: closeSVG,
         zoomSVG: zoomSVG,
         gallery: `#my-gallery${(',#' + mainDivId) || ''}`,
         children: 'a',
         pswpModule: PhotoSwipe,
         bgOpacity: 1,
         padding: { top: 56, bottom: 36, left: 0, right: 0 },
         initialZoomLevel: 'fit',
         secondaryZoomLevel: 1.5,
         maxZoomLevel: 1,
      });
      // const temporaryDataSource = [];
      // $('#my-gallery a').each(function(index) {
      //   const element = $('#my-gallery a').eq(index);
      //   const temporaryItem = {}
      //   temporaryItem.src = element.attr('href');
      //   temporaryItem.width = element.attr('data-pswp-width');
      //   temporaryItem.height = element.attr('data-pswp-height');
      //   temporaryItem.alt = element.find('img').attr('alt');
      //   temporaryDataSource.push(temporaryItem);
      // });
      // lightbox.options.dataSource = temporaryDataSource;

      function lightboxInit(el, pswp) {}

      lightbox.on('uiRegister', function() {
         lightbox.pswp.ui.registerElement({
          name: 'custom-caption',
          order: 9,
          isButton: false,
          appendTo: 'root',
          html: 'Caption text',
          onInit: (el, pswp) => {
            lightbox.pswp.on('change', () => {
              const currSlideElement = lightbox.pswp.currSlide.data.element;
              let captionHTML = '';
              if (currSlideElement) {
                  const hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');
                  if (hiddenCaption) {
                    // get caption from element with class hidden-caption-content
                    captionHTML = hiddenCaption.innerHTML;
                  } else {
                    // get caption from alt attribute
                    captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
                  }
              }
              el.innerHTML = captionHTML && captionHTML !== 'null' ? captionHTML : '';
            });
          }
         });
         lightbox.pswp.ui.registerElement({
            name: 'full-screen',
            ariaLabel: 'FullScreen',
            order: 9,
            isButton: true,
            html: fullScreenSVG,
            onClick: (event, el) => {
               if(!is_fullScreen) {
                  requestFullscreen(document.querySelector('.pswp'));
               } else {
                  exitFullscreen();
               }
            }
         });
         lightbox.pswp.ui.registerElement({
            name: 'share',
            ariaLabel: 'Share',
            order: 9,
            isButton: true,
            html: shareSVG,
            onClick: (event, el) => {
               if($('.pswp__share') != null){
                  $('.pswp').append('<div class="pswp__share"><ul><li class="pswp__share__facebook"><a target="_blank">Share on Facebook</a></li><li class="pswp__share__x"><a target="_blank">Post</a></li><li class="pswp__share__download"><div>Download Image</div></li></ul></div>');

                  let facebookUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href);
                  $('.pswp__share__facebook a').attr('href',facebookUrl);

                  let xUrl = 'https://x.com/intent/post?text=';
                  xUrl += encodeURIComponent($('.pswp__custom-caption').text());
                  xUrl += '&url=';
                  xUrl += encodeURIComponent(location.href);
                  $('.pswp__share__x a').attr('href',xUrl);

                  $('.pswp__share__download div').on('click', function(){
                     downloadImage();
                  });
               };

               if($('.pswp__share').css('display') == 'block') {
                  $('.pswp__share').stop().fadeOut(300);
               } else {
                  $('.pswp__share').stop().fadeIn(300);
               }
            }
         });
      });

      lightbox.on('contentLoadImage', ({ content, isLazy }) => {
         $(content.element).on('load', (e) => {
            let link = $(content.data.element);
            const naturalWidth = e.currentTarget.naturalWidth * 1.5;
            const naturalHeight = e.currentTarget.naturalHeight * 1.5;
            // Set the image size if the height is larger than widtth
            if (
               e.currentTarget.width < e.currentTarget.height &&
               content.width > content.height
            ) {
               if (content.slide) {
                  // Swap between the values
                  let swapVal = content.slide.width;
                  content.slide.width = content.slide.height;
                  content.slide.height = swapVal;
               } else {
                  let swapVal = content.width;
                  content.width = content.height;
                  content.height = swapVal;
               }

               if (link.attr('data-pswp-width') > link.attr('data-pswp-height')) {
                  link.attr('data-pswp-width', naturalWidth);
                  link.attr('data-pswp-height', naturalHeight);
               }
            } else {
               // If the width and height have already been set, not update the pswp
               if (content.width === e.currentTarget.width && content.height === e.currentTarget.height) {
                  return;
               }
               if (content.slide) {
                  content.slide.width = e.currentTarget.width;
                  content.slide.height = e.currentTarget.height;
               } else {
                  content.width = e.currentTarget.width;
                  content.height = e.currentTarget.height;
               }
               link.attr('data-pswp-width', naturalWidth);
               link.attr('data-pswp-height', naturalHeight);
            }
            content.instance.updateSize(true); // Update pswp
         });
      });

      lightbox.on('close', () => {
         $('.pswp__share').stop().hide();
      });

      lightbox.init();

      function downloadImage() {
         const temporarySrc = lightbox.pswp.currSlide.data.src;
         const element = document.createElement('a');
         element.href = temporarySrc;
         element.download = temporarySrc.split('/').slice(-1)[0];
         element.target = '_blank';
         element.click();
      }
